import React from 'react';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { ReactActionDialogOptionsForConfirmationDialog, ReactConfirmationDialogBodyProps } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { AdminProfileErrorCode } from '~src/commonInfra/utils/ErrorCodes';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IAdminProfile } from '../models/IAdminProfile';
import { AdminProfilesService } from './AdminProfilesService';

export const DeleteAdminProfileDialogBodyTestId = 'delete-admin-profile-confirmation-dialog-body';

function DeleteAdminProfileConfirmationDialogBody(props: ReactConfirmationDialogBodyProps): JSX.Element {
    return (
        <div data-tb-test-id={DeleteAdminProfileDialogBodyTestId}>
            <div style={{ whiteSpace: 'pre-wrap' }}>
                {props.message}
            </div>
        </div>
    );
}

export function showDeleteAdminProfileDialog(
    profile: IAdminProfile,
    onSuccess: () => void
): void {
    const actionDialogOptions: ReactActionDialogOptionsForConfirmationDialog<string, IResult> = {
        title: Messages.deleteAdminProfileDialogTitle(),
        bodyComponent: DeleteAdminProfileConfirmationDialogBody,
        initialBodyProps: { message: Messages.deleteAdminProfileConfirmMessage({ PROFILE_NAME: profile.name }) },
        initialDialogState: profile.luid,
        actionName: Messages.adminProfileHeaderDeleteButton(),
        action: (_props, profileLuid) => deleteAdminProfileAction(profileLuid, profile.name, onSuccess),
        dialogWidth: TabDialogWidth.width375px,
        dismissDialogOnActionFailed: true,
        isActionDelete: true,
    };

    openReactActionDialog(actionDialogOptions);
}

async function deleteAdminProfileAction(
    profileLuid: string,
    profileName: string,
    onSuccess: () => void
): Promise<IResult> {
    const result = await AdminProfilesService.deleteAdminProfile(profileLuid);
    return notify(result, profileName, onSuccess);
}

function notify(
    result: IResult,
    profileName: string,
    onSuccess: () => void
): Promise<IResult> {
    if (!!result.errors && result.errors.length > 0) {
        const errorMsg = errorMessageFor(Number(result.errors[0].code));
        ToasterService.instance.pop({ type: ToastType.Error, text: errorMsg });
        return Promise.resolve(result);
    } else {
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.deleteAdminProfileSuccess({ PROFILE_NAME: profileName }) });
        onSuccess();
        return Promise.resolve(result);
    }
}

function errorMessageFor(errorCode: number): string {
    switch (errorCode) {
        case AdminProfileErrorCode.AdminProfileNotFound:
            return Messages.deleteAdminProfileNotFound();
        default:
            return Messages.deleteAdminProfileFailed();
    }
}

export const DeleteAdminProfileDialogAction = {
    notify,
    errorMessageFor,
};

export type DeleteAdminProfileDialogAction = typeof DeleteAdminProfileDialogAction;
